// Returns App Config
export const RemoteConfigService_AppConfigLazy = () =>
  import("./service.grpc").then((m) => m.RemoteConfigService_AppConfig);
RemoteConfigService_AppConfigLazy.method =
  "aysa_api.services.remote_config.RemoteConfigService/AppConfig" as const;

// Returns Web Config
export const RemoteConfigService_WebConfigLazy = () =>
  import("./service.grpc").then((m) => m.RemoteConfigService_WebConfig);
RemoteConfigService_WebConfigLazy.method =
  "aysa_api.services.remote_config.RemoteConfigService/WebConfig" as const;
